/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect, useState } from 'react'
import { Grid, Typography } from '@mui/material'
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";

am4core.addLicense("CH208466903");

const BAOverlapPieChart = (props) => {

    const { sBA,data } = props

    useEffect(() => {

        if (data.length > 0) {
            (data).forEach((element, idx) => {
                
                onRenderGraphPie(element.lstGraphPieParent, element.lstGraphPieChild, element.sTitle, element.sID, element.isDisplay,idx,element.lstdataLegend);
            });
        }

    }, [data])

    const onRenderGraphPie = (dataParent, dataChild, sBA, sID, isDisplay, idx, lstdataLegend) => {

        let chart = am4core.create(`ba-overlap_${idx}`, am4charts.PieChart);

        chart.innerRadius = am4core.percent(40);
        let label = chart.seriesContainer.createChild(am4core.Label);
        label.text = sBA;
        label.horizontalCenter = "middle";
        label.verticalCenter = "middle";
        label.fontSize = 25;

        if (isDisplay != true) {
            chart.data = [{
                "country": "Dummy",
                "disabled": true,
                "value": 1000,
                "color": am4core.color("#dadada"),
                "opacity": 0.3,
                "strokeDasharray": "4,4",
                "tooltip": ""
            }];

            /* Create series */
            var series = chart.series.push(new am4charts.PieSeries());
            series.dataFields.value = "value";
            series.dataFields.category = "country";

            /* Set up slice appearance */
            var slice = series.slices.template;
            slice.propertyFields.fill = "color";
            slice.propertyFields.fillOpacity = "opacity";
            slice.propertyFields.stroke = "color";
            slice.propertyFields.strokeDasharray = "strokeDasharray";
            slice.propertyFields.tooltipText = "tooltip";

            series.labels.template.propertyFields.disabled = "disabled";
            series.ticks.template.propertyFields.disabled = "disabled";
        }
        else {

            // Add and configure Series
            let pieSeries = chart.series.push(new am4charts.PieSeries());
            pieSeries.dataFields.value = "value";
            pieSeries.dataFields.category = "category";
            pieSeries.slices.template.stroke = am4core.color("#fff");
            pieSeries.innerRadius = 10;
            pieSeries.slices.template.fillOpacity = 0.5;
            // pieSeries.labels.template.text = "{category}: {value.percent.formatNumber('#.00')}%";
            pieSeries.labels.template.text = "{value}, {sPercent}%";
            pieSeries.slices.template.tooltipText = "{category}: {value}, {sPercent}%";
            pieSeries.legendSettings.itemValueText = "{sPercent}%[/]";

            pieSeries.slices.template.propertyFields.disabled = "labelDisabled";
            pieSeries.labels.template.propertyFields.disabled = "labelDisabled";
            pieSeries.ticks.template.propertyFields.disabled = "labelDisabled";
            // pieSeries.hiddenInLegend = true;
            pieSeries.labels.template.maxWidth = 150;
            pieSeries.labels.template.fontSize = 10;
            pieSeries.labels.template.wrap = true;
            pieSeries.alignLabels = false;

            // Add data
            pieSeries.data = dataParent;

            // Disable sliding out of slices
            pieSeries.slices.template.states.getKey("hover").properties.shiftRadius = 0;
            pieSeries.slices.template.states.getKey("hover").properties.scale = 1;


            // Add second series
            let pieSeries2 = chart.series.push(new am4charts.PieSeries());
            pieSeries2.dataFields.value = "value";
            pieSeries2.dataFields.category = "category";
            pieSeries2.slices.template.states.getKey("hover").properties.shiftRadius = 0;
            pieSeries2.slices.template.states.getKey("hover").properties.scale = 1;
            pieSeries2.slices.template.propertyFields.fill = "fill";
            // pieSeries2.labels.template.text = "{category}: {value.percent.formatNumber('#.00')}%";
            // pieSeries2.slices.template.tooltipText = "{category}: {value.percent.formatNumber('#.00')}%";
            pieSeries2.labels.template.text = "{value}, {sPercent}%";
            pieSeries2.slices.template.tooltipText = "{category}: {value}, {sPercent}%";
            pieSeries2.alignLabels = true;
            pieSeries2.legendSettings.itemValueText = "";

            pieSeries2.labels.template.fontSize = 10;
            // Add data
            pieSeries2.data = dataChild;


            pieSeries.adapter.add("innerRadius", function (innerRadius, target) {
                return am4core.percent(40);
            })

            pieSeries2.adapter.add("innerRadius", function (innerRadius, target) {
                return am4core.percent(60);
            })

            pieSeries.adapter.add("radius", function (innerRadius, target) {
                return am4core.percent(100);
            })

            pieSeries2.adapter.add("radius", function (innerRadius, target) {
                return am4core.percent(80);
            })

            chart.legend = new am4charts.Legend();
            chart.legend.labels.template.text = "{category}";
            chart.legend.valueLabels.template.disabled = true;
            chart.legend.position = "right";
            chart.legend.fontSize = 12;
            chart.legend.marginTop = 0;
            chart.legend.marginBottom = 0;
            chart.legend.align = "left";
            chart.legend.maxHeight = 155;
            // chart.legend.clickable = false;
            // chart.legend.scrollable = true;
            chart.legend.itemContainers.template.clickable = false;
            chart.legend.itemContainers.template.focusable = false;
            // // Custom legend
            // var legend = new am4charts.Legend();
            // legend.parent = chart.chartContainer;
            // // legend.align = "right";
            // legend.position = "bottom";
            // legend.fontSize = 12;
            // legend.marginTop = 0;
            // legend.marginBottom = 0;
            // legend.valueLabels.template.text = "{sPercent}%";
            // legend.data = lstdataLegend;
        }

        setTimeout(() => {
            chart.exporting.getImage("png").then((data) => {
                let obj = {
                    id: 40+idx,
                    sDesc: "overlap"+sID,
                    sName : "",
                    idDiv : 5,
                    imgBase64: data
                }
                props.exportImg && props.exportImg(obj);
            });
        }, 2000);
    }

    return (
        <>
            <Grid container spacing={1} direction="row" justifyContent="center" alignItems="center" >
            <Grid item xs={12}>
                    <Typography style={{fontWeight:500}}>กลุ่มตลาด: {sBA}</Typography>
                </Grid>
                {
                    data.length > 0 ?
                        data.map((element, index) => {
                            return (
                                <Fragment key={`overlap_F_${index}`}>
                                    <Grid item xs={12} sm={6} >
                                        <Grid container spacing={1} direction="row" justifyContent="center" alignItems="center" >
                                            <Grid item xs={12}>
                                                <div id={`ba-overlap_${index}`} style={{ width: "100%", height: "220px" }}></div>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Fragment>
                            )
                        })
                        : null
                }
            </Grid>
        </>
    )
}

export default BAOverlapPieChart